const DynamicUpdateAction = {
  HideAndClear: 1,
  DisableAndClear: 2
};

export default DynamicUpdateAction;
